const initialState = {
  fetching: false,
  fetched: false,
  data: null,
  error: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'LISTING_ADVENTURES_FETCH_PENDING': {
      return {
        ...state,
        fetching: true,
      }
    }

    case 'LISTING_ADVENTURES_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }
    }

    case 'LISTING_ADVENTURES_FETCH_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload.data,
      }
    }

    case 'LISTING_ADVENTURES_FETCH_SILENT_REJECTED': {
      return {
        ...state,
        error: action.payload,
      }
    }

    case 'LISTING_ADVENTURES_FETCH_SILENT_FULFILLED': {
      return {
        ...state,
        data: action.payload.data,
      }
    }

    case 'LISTING_ADVENTURES_CREATE_PENDING': {
      return {
        ...state,
        creating: true,
      }
    }

    case 'LISTING_ADVENTURES_CREATE_REJECTED': {
      return {
        ...state,
        creating: false,
        error: action.payload,
      }
    }

    case 'LISTING_ADVENTURES_CREATE_FULFILLED':
    case 'LISTING_ADVENTURES_UPDATE_FULFILLED':
    case 'LISTING_ADVENTURES_DELETE_FULFILLED': {
      return {
        ...state,
        creating: false,
        data: action.payload.data,
      }
    }

    default: {
      return state
    }
  }
}
